import { Box, Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Subscription Success</title>
      </Helmet>
      <Container maxWidth="md" sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{ mb: 4 }}>
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 2 
            }} 
          />
          <Typography variant="h2" component="h1" gutterBottom>
            Thank You for Subscribing!
          </Typography>
          <Typography variant="h5" color="textSecondary" paragraph>
            Your subscription has been successfully activated. You now have access to all premium features.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </Button>
      </Container>
    </>
  );
};
